import React, { Component, PropTypes } from 'react';
import './MessageBar.css';

class MessageBar extends Component {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.onClick();
  }

  render() {
    const { message, messageType } = this.props;

    if(!message) return null;

    return (
      <div>
        <div
          onClick={this.handleClick}
          className={ message ? messageType + " " + messageType + "-active" : messageType}>
          <p className={messageType + "-text"}>{this.props.message}</p>
        </div>
      </div>
    );
  }
}

MessageBar.propTypes = {
  messageType: PropTypes.string.isRequired,
  message: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

export default MessageBar;



/** WEBPACK FOOTER **
 ** ./src/components/MessageBar/index.js
 **/